<template>
  <header class="estrut-hub-header">
    <nav class="estrut-hub-header__breadcrumb" :aria-label="t('common.breadcrumb.dashboard')">
      <button type="button" class="estrut-hub-header__link" @click="$router.push('/dashboard')">
        {{ t('common.breadcrumb.dashboard') }}
      </button>
      <span class="estrut-hub-header__sep" aria-hidden="true">/</span>
      <span class="estrut-hub-header__current">{{ t('estruturacao.breadcrumb') }}</span>
    </nav>

    <a
      :href="whatsappUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="estrut-hub-header__whatsapp"
    >
      <svg class="estrut-hub-header__whatsapp-icon" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
      <span class="estrut-hub-header__whatsapp-text">{{ t('estruturacao.hubWhatsappCta') }}</span>
    </a>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { COMMERCIAL_WHATSAPP_URL } from '../../config/supportContact'

const { t } = useI18n()

const whatsappUrl = computed(() => {
  const text = encodeURIComponent(t('estruturacao.hubWhatsappMessage'))
  return `${COMMERCIAL_WHATSAPP_URL}?text=${text}`
})
</script>

<style scoped>
.estrut-hub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 44px;
  padding: 8px 24px;
  border-bottom: 1px solid var(--border-primary);
  background: var(--bg-primary);
}

.estrut-hub-header__breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 12px;
  line-height: 1.2;
}

.estrut-hub-header__link {
  padding: 0;
  border: none;
  background: none;
  color: var(--text-secondary);
  font-size: inherit;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.estrut-hub-header__link:hover {
  color: var(--text-primary);
}

.estrut-hub-header__sep {
  color: var(--text-tertiary);
  user-select: none;
}

.estrut-hub-header__current {
  color: var(--text-primary);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.estrut-hub-header__whatsapp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 9999px;
  border: 1px solid color-mix(in srgb, #25d366 45%, transparent);
  background: color-mix(in srgb, #25d366 12%, transparent);
  color: #16a34a;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.estrut-hub-header__whatsapp:hover {
  background: color-mix(in srgb, #25d366 20%, transparent);
  border-color: color-mix(in srgb, #25d366 60%, transparent);
  transform: translateY(-1px);
}

.estrut-hub-header__whatsapp-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .estrut-hub-header {
    padding: 8px 16px;
  }

  .estrut-hub-header__whatsapp-text {
    display: none;
  }

  .estrut-hub-header__whatsapp {
    padding: 8px;
    border-radius: 9999px;
  }
}
</style>
